import * as React from 'react'
import clx from 'classnames'

import { ProgressIcon } from '../icons/Progress'
import { SkeletonBox } from './SkeletonBox'

type Props = {
  icon?: React.ReactNode
  description: string
  data: string | number
  percentage?: number
  className?: string
  isLoading?: boolean
}

export const DataBox = ({
  icon,
  description,
  data,
  percentage,
  className,
  isLoading,
}: Props) => {
  return (
    <div className={clx('tw-flex tw-flex-col tw-gap-1.5', className)}>
      {icon}
      <div>
        <div className="tw-flex tw-items-center tw-gap-1">
          {isLoading ? (
            <SkeletonBox className="tw-my-1 tw-h-5 tw-w-28" />
          ) : (
            <p className="tw-mb-0 tw-text-xl tw-font-bold">{data}</p>
          )}
          {!isLoading && percentage !== undefined && percentage !== null && (
            <p
              className={clx(
                `tw-mb-0 tw-flex tw-items-center tw-text-sm tw-font-bold`,
                {
                  'tw-text-success': percentage > 0,
                  'tw-text-error': percentage < 0,
                  'tw-text-inherit': percentage === 0,
                },
              )}
            >
              <span className="tw-m-0.5 tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center">
                <ProgressIcon
                  className={clx('', {
                    'tw-rotate-90': percentage < 0,
                  })}
                />
              </span>
              {percentage}%
            </p>
          )}
        </div>
        <p className="tw-mb-0 tw-text-xs">{description}</p>
      </div>
    </div>
  )
}
